import React from "react"

import "~css/default.css"
import "~css/fonts.css"
import { body } from "./DefaultLayout.module.scss"

const DefaultLayout = ({ children }) => <div className={body}>{children}</div>

export default DefaultLayout
